import { createSelector } from '@reduxjs/toolkit';
import { GetApiDimensionsResponse } from '@sit/client-shared';
import { ReduxStore } from '../../types/redux/state';
import { BuildType, DevOverrides } from '../Development';

// Dimension related
const getBuildType = (state: ReduxStore) => state.development.buildType;
const getDevOverrides = (state: ReduxStore) => state.development.devOverrides;
const getTimesheetStatusStoreData = (state: ReduxStore) => state.timesheetStatus;

// helpers
export const findDepartmentDimension = (dimensionsData: GetApiDimensionsResponse | undefined) =>
  (dimensionsData || []).find((d) => d.integrationMeta?.objectName === 'DEPARTMENT');
export const findLocationDimension = (dimensionsData: GetApiDimensionsResponse | undefined) =>
  (dimensionsData || []).find((d) => d.integrationMeta?.objectName === 'LOCATION');

/**
 *     Clusters
 */
export const selectBuildType = createSelector(getBuildType, (buildType): BuildType => {
  return buildType;
});

export const selectDevOverrides = createSelector(getDevOverrides, (overrides): DevOverrides => {
  return overrides;
});

export const selectIsTimesheetSaving = createSelector(
  getTimesheetStatusStoreData,
  ({ pendingResponses }): boolean => Object.keys(pendingResponses).length > 0,
);

export const selectIsPendingResponse = createSelector(
  getTimesheetStatusStoreData,
  (state: ReduxStore, operationName: string) => operationName,
  ({ pendingResponses }, operationName): boolean => pendingResponses[operationName] !== undefined && pendingResponses[operationName] > 0,
);
